module.exports = __webpack_public_path__ + "img/facebook.32922892.svg";